import { AlertCircle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { HttpError } from "@/types/error";

export function ErrorMessage({
  error,
}: {
  error: HttpError | null | undefined;
}) {
  const isForbidden = error?.statusCode === 403;
  const isNotFound = error?.statusCode === 404;

  const title = isForbidden
    ? "Forbidden resource"
    : isNotFound
      ? "404 - Not found"
      : "Error";
  const description = isForbidden
    ? "You are not authorized to access this resource. If you believe this is an error, please contact support."
    : (error?.message ?? "An unexpected error occurred");
  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Alert>
  );
}
